<template>
  <div class="boot-video-container">
    <a-icon class="boot-video-close" type="close" @click="closeVideo" />
    <video
      id="videoElement"
      ref="video"
      class="boot-video-content"
      controls
      autoplay
      width="480"
      height="270"
      muted
    >
      Your browser is too old which doesn't support HTML5 video.
    </video>
    <!-- <div class="controls">
      <a-button
        @click="flv_start"
        size="small"
        type="primary"
        style="margin: 0 4px"
        >开始</a-button
      >
      <a-button
        @click="flv_pause"
        size="small"
        type="primary"
        style="margin: 0 4px"
        >暂停</a-button
      >
      <a-button
        @click="flv_destroy"
        size="small"
        type="primary"
        style="margin: 0 4px"
        >停止</a-button
      >
      <a-input v-model="num" style="width: 100px" />
      <a-button
        @click="flv_seekto"
        size="small"
        type="primary"
        style="margin: 0 4px"
        >跳转</a-button
      >
    </div> -->
  </div>
</template>

<script>
import { isCheckNumber } from "@/utils/utils";
export default {
  name: "BoatRealVideo",
  data() {
    return {
      player: null,
      num: null
    };
  },
  props: ["board_id", "url"],
  async mounted() {
    try {
      if (flvjs.isSupported()) {
        this.player = flvjs.createPlayer(
          {
            type: "flv",
            url: this.url,
            isLive: true,
            hasAudio: false,
            hasVideo: true
            //withCredentials: false,
            //cors: true
          },
          {
            enableWorker: true, // 开启多线程
            enableStashBuffer: false,
            lazyLoad: false,
            lazyLoadMaxDuration: 0,
            lazyLoadRecoverDuration: 0,
            deferLoadAfterSourceOpen: false,
            fixAudioTimestampGap: true,
            autoCleanupSourceBuffer: true
          }
        );
        this.player.attachMediaElement(this.$refs.video);
        this.player.load(); //加载
        this.flv_start();
      }
    } catch (error) {
      console.log(error);
    }
  },
  beforeDestroy() {
    this.flv_destroy();
  },
  methods: {
    closeVideo() {
      this.flv_destroy();
      this.$emit("close");
    },
    flv_start() {
      this.player?.play();
    },

    flv_pause() {
      this.player?.pause();
    },

    flv_destroy() {
      this.player?.pause();
      this.player?.unload();
      this.player?.detachMediaElement();
      this.player?.destroy();
      this.player = null;
    },

    flv_seekto() {
      if (isCheckNumber(this.num)) {
        this.player.currentTime = parseFloat(this.num);
      } else {
        this.num = null;
        this.$message.warning("请输入数字");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.boot-video-container {
  position: relative;
  width: 480px;
  height: 270px;
  background: #fff;
}
.boot-video-close {
  position: absolute;
  right: 4px;
  top: -15px;
  border-radius: 50%;
  background: #fff;
  padding: 6px;
  z-index: 100;
}

.boot-video-content {
  display: block;
  object-fit: fill;
  border-radius: 4px;
  // width: 100%;
  // height: 100%;
}

.controls {
  display: block;
  width: 100%;
  margin: 10px 0;
  text-align: left;
  margin-left: auto;
  margin-right: auto;
}
</style>
